import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { alert } from 'devextreme/ui/dialog';
import { OverlaySideFormService } from '../../components/shared/overlay-side-form/overlay-side-form.service';
import { ComponentService } from '../../services/component.service';


@Component({
  selector: 'app-nica-maps',
  templateUrl: './nica-maps.component.html',
  styleUrls: ['./nica-maps.component.css']
})
export class NicaMapsComponent implements OnInit, AfterViewInit {

  @Input() itemData: any;
  latLng: any;
  @Output() coordinateEmitter: EventEmitter<google.maps.LatLng | undefined> = new EventEmitter<google.maps.LatLng | undefined>();

  pulsanteSalvaCoordinate = {

    location: "after",
    stylingMode: "text",
    widget: "dxButton",
    locateInMenu: "never",
    text: 'Salva',
    icon: "glyphicon mdi mdi-content-save-outline",
    event: 'salva',
    cssClass: 'escludiQuesto',
    onClick: () => {

      if (this.latLng)
        this.coordinateEmitter.emit(this.latLng);

    }
  }


  constructor(public usercomponent: ComponentService) { }




  ngOnInit() {

    this.initMap();
  }


  ngAfterViewInit(): void {
    //this.initMap();  
  }

  // Initialize and add the map
  async initMap() {
    console.log(this.itemData[0]);

    if (!this.itemData[0].dati)
      return;

    if (typeof this.itemData[0].dati === 'string') {

      let indirizzoPerGeocoding = `${this.itemData[0].dati.split(',')[0]},${this.itemData[0].dati.split(',')[1].replace(/[0-9]+/g, "")}`


      let geocoder = new google.maps.Geocoder();



      var geocoderResponse = await geocoder.geocode({
        address: indirizzoPerGeocoding
      });

      this.itemData[0].dati = indirizzoPerGeocoding;

      console.warn(geocoderResponse)

      if
        (
        typeof this.itemData[0].dati === 'string' &&
        geocoderResponse.results[0].formatted_address.split(',').length !== 4 && geocoderResponse.results[0].formatted_address.split(',').length !== 3
        //!this.itemData[0].dati.split(',')[0].toLowerCase().replace(/[0-9 ]+/g, "").trim().includes(geocoderResponse.results[0].address_components[0].long_name.toLowerCase().replace(/[0-9 ]+/g, "").trim())
      ) {

        this.coordinateEmitter.emit(undefined);

        alert(`Indirizzo "${this.itemData[0].dati.split(',')[0].replace(/[0-9]+/g, "").trim()}" non valido per il Comune selezionato`, 'Attenzione');

        this.salvaCoordinate(16);

        return;

      }



    }





    let indirizzo: string;


    if (typeof geocoderResponse !== 'undefined')
      indirizzo = geocoderResponse.results[0].formatted_address;
    else
      indirizzo = this.itemData[0].dati['address'];


    let coordinateGeografiche = (this.itemData[0].dati.lat && this.itemData[0].dati.lng) ? new google.maps.LatLng({ lat: parseFloat(this.itemData[0].dati.lat), lng: parseFloat(this.itemData[0].dati.lng) }) : geocoderResponse.results[0].geometry.location;



    if (!coordinateGeografiche)
      return;

    this.latLng = coordinateGeografiche;


    //this.coordinateEmitter.emit(coordinateGeografiche);


    const map = new google.maps.Map(
      document.getElementById("map") as HTMLElement,
      {
        zoom: 10,
        center: coordinateGeografiche
      }
    );

    document.getElementById("map").style.width = "800px";
    document.getElementById("map").style.height = "600px";
    document.getElementById("map").style.overflow = "auto";

    const marker = new google.maps.Marker({
      position: coordinateGeografiche,
      map: map,
      draggable: true,

    });

    let infoWindow = new google.maps.InfoWindow({
      content: `
      <div style='padding-right: 20px;'>  
        ${indirizzo}<br>
        <ul>
          <li>Latitudine: ${coordinateGeografiche.lat()}</li>
          <li>Longitudine: ${coordinateGeografiche.lng()}</li>
        </ul>  
      </div>`
    });

    //remove overflow scrollbars

    marker.addListener("click", (e) => {
      infoWindow.open({
        anchor: marker,
        map
      });

      setTimeout(
        () => {

          (document.getElementsByClassName('gm-style-iw-d').item(0) as HTMLElement).style.overflow = 'visible';
        }
      ), 50
    });
    //$('#scrollFix').parent().parent().parent().css('overflow','');



    google.maps.event.addListener(map, "click", function () {
      infoWindow.close();
    });



    marker.addListener("dragend", (e) => {
      console.log(e.latLng);

      infoWindow.setContent(`
      <div style='padding-right: 20px;'>
        ${indirizzo}<br>
        <ul>
          <li>Latitudine: ${e.latLng.lat()}</li>
          <li>Longitudine: ${e.latLng.lng()}</li>
        </ul>
      </div>  
    `);

      this.latLng = e.latLng;



    })
  }

  salvaCoordinate($event) {
    
    switch ($event) {
      case 27:       
      case 15:
        if (this.latLng)
          this.coordinateEmitter.emit(this.latLng);
        break;
      case 16:
        //Non è corretto ciò che sto facendo, 
        //dovrei ottener la guid del popup in cui mi trovo o quantomeno emettere all'esterno un comando per identificare l'uscita ma mi scoccio
        this.usercomponent.destroyCurrentOpenPopUp('NicaMapsComponent')
        break;

      default:
        break;
    }
   
  }

}
